export enum FilterType {
  selection = 'selection',
  sort = 'sort',
  checkBox = 'checkBox',
  radioBox = 'radioBox',
  textSearch = 'textSearch',
}
